import { render } from "./PredDisplay.vue?vue&type=template&id=7de07bac&scoped=true"
import script from "./PredDisplay.vue?vue&type=script&lang=js"
export * from "./PredDisplay.vue?vue&type=script&lang=js"

import "./PredDisplay.vue?vue&type=style&index=0&id=7de07bac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7de07bac"

export default script